/**
 * Creates hierarchical menu based on WordPress menu.
 * @link https://www.wpgraphql.com/docs/menus/#hierarchical-data
 */

const mainNavScripts = ( props ) => {

	// reset overflow on every menu load
	document.body.style.overflow = "auto";

	let scrollTopPos = 0;

  function showSearch(){
    if(document.getElementById('searchbar')) {

      const target = document.body

      // document.getElementById('searchbar').classList.remove('active')
      target.classList.remove('algolia-open')

      // Click on search input and open algolia
      document.getElementById('search-nav').addEventListener('click', function (item) {
        if(!target.classList.contains('algolia-open')){
					// save current scroll position
					scrollTopPos = document.documentElement.scrollTop || document.body.scrollTop;
					// scroll up
					document.documentElement.scrollTop = document.body.scrollTop = 0;
          document.getElementById('searchbar').classList.add('active')
          document.getElementById('algoliaInput').focus()
          target.classList.add('algolia-open')
          document.querySelector("body").style.overflowY = 'hidden';
        }
      })

      //Click on close button
      document.getElementById('close-algolia').addEventListener('click', function (item) {
        if(target.classList.contains('algolia-open')){
					// scroll back to saved position
					document.documentElement.scrollTop = document.body.scrollTop = scrollTopPos;
          document.getElementById('searchbar').classList.remove('active')
          target.querySelector('input').blur()
          target.classList.remove('algolia-open')
          document.querySelector("body").style.overflowY = 'auto';
        }
      })

    }
  }
  // showSearch()


  // HELPERS FUNCTIONS
  // ---------------------------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------------------


  // Share active class from .nav-link to parent menu elements
  function shareActiveClassToParents(activeItem){
    if(activeItem != null){
      var parent = activeItem.closest('ul.dropdown-menu');
      if(parent == null){
        return null;
      } else {
        parent.closest('.drop-container').previousSibling.classList.add('active');
        shareActiveClassToParents(parent.closest('.drop-container').previousSibling);
      }
    }
  }


  // Get menu total levels
  function getMenuLevels(mainActiveItem, counter){
    var counter = counter || 0

    if(mainActiveItem != null){

      var nextLevel = mainActiveItem.classList.contains('dropdown-toggle') ? mainActiveItem.nextElementSibling : mainActiveItem;
      var foundNextLevel = nextLevel.querySelector('ul.dropdown-menu.show');

      if(foundNextLevel == null){

        nextLevel.closest('.main-dc').setAttribute('data-menu-level', counter);

        return counter;
      } else {
        counter++;
        nextLevel.closest('.main-dc').setAttribute('data-menu-level', counter);
        getMenuLevels(foundNextLevel, counter);
      }
    }
  }


  // Assign active class to body and menu elements
  function showHideListners(masterMenuItem, mainItem){

    // EVENT show.bs.dropdown ----------------------
    // OPEN .drop-container.main-dc when main dropdown is shown
    mainItem.addEventListener('show.bs.dropdown', function (item) {
      // get first .drop-container of active dropdown
      let activeContainer = item.target.nextElementSibling;
      // Active class to this .drop-container.main-dc
      document.querySelectorAll(masterMenuItem + ' .main-dc').forEach(function(elem){
        elem.classList.remove('active-container');
      })
      activeContainer.classList.add('active-container');
      document.body.classList.add('open-menu');
    })

    // EVENT hide.bs.dropdown ----------------------
    // OPEN .drop-container.main-dc when main dropdown is shown
    mainItem.addEventListener('hide.bs.dropdown', function (item) {
      // Active class to this .drop-container.main-dc
      document.querySelectorAll(masterMenuItem + ' .main-dc').forEach(function(elem){
        elem.classList.remove('active-container');
      })
      document.body.classList.remove('open-menu');
    })
  }


  // MAIN DROPDOWN INSTANCE
  function initMainDropdown(element, popperOffsetX, popperOffsetY){

    // console.log('called by', element);

    return new bootstrap.Dropdown(element, {
      boundary: document.querySelector('#navbarNavDropdown .navbar-nav'),
      popperConfig: function (defaultBsPopperConfig) {
        return {
          placement: "bottom-start",
          strategy: "absolute",
          preventOverflow: true,
          requiresIfExists: ['offset'],
          modifiers: [
            {
              name: 'mainPopperModifier',
              enabled: true,
              phase: 'main',
              fn({ instance }) {
              },
              options: {
                fallbackPlacements: ['bottom'],
                preventOverflow: {
                    enabled: false,
                    boundariesElement: document.querySelector('#navbarNavDropdown .navbar-nav'),
                    escapeWithReference: true
                },
              },
            },
            {
              name: 'offset',
              options: {
                offset: ({ placement, reference, popper }) => {
                  return [ popperOffsetX || -30 , 0];
                },
              },
            },
          ],
        };
      },
      offset : [ popperOffsetX || -30 , 0]
    })
  }


  // FIRST CHILD DROPDOWN INSTANCE
  function initFirstChildDropdown(element, reference, popperOffsetX, popperOffsetY){
    return new bootstrap.Dropdown(element, {
      // boundary: document.querySelector('#navbarNavDropdown .navbar-nav'),
      reference:  reference,
      popperConfig: function (defaultBsPopperConfig) {
        return {
          strategy: "absolute",
          placement: 'right-start',
          modifiers: [
            {
              name: 'flip',
              options: {
                fallbackPlacements: ['right-start', 'bottom'],
              },
            },
          ],
        };
      }
    })
  }


  // DROP-CONTAINER SIZING
  function dropContainerSize(options){

		// SCROLL HEIGHT - handle sticky menu topbar
		var topNavbarHeight = document.getElementById('top-navbar').clientHeight;
		var topScroll = (window.pageYOffset || document.body.scrollTop)  - (document.body.clientTop || 0);
		if(topScroll < topNavbarHeight){
			var addSpace = topNavbarHeight - topScroll
		} else {
			var addSpace = 0
		}

    // MENU INDICATOR
    // dropdown chevron (indicator)
    const ddchevron = document.getElementById('dropdown-chevron');

    // active menu element
    var ddActiveRect =  document.querySelector('.main-dt.show');
    if(ddActiveRect){
      var ddActiveRect = ddActiveRect.getBoundingClientRect()

      // define chevron (indicator) dimension and position
      ddchevron.style.left = `${ddActiveRect.left}px`;
      ddchevron.style.top = `${ddActiveRect.bottom - addSpace}px`;
      ddchevron.style.width = `${ddActiveRect.width}px`;


      // CONTAINER BACKGROUND
      // dropdown background (container)
      const ddBg = document.getElementById('dropdown-bg');

      // first dropdown element
      const clientRect =  document.querySelector('.main-dc.active-container > .dropdown-menu.show').getBoundingClientRect();

      // coordinates
      var ccLeft = clientRect.left;
      var ccRight = clientRect.right;
      var ccTop = clientRect.top;
      var ccBottom = clientRect.bottom;
      var ccW = clientRect.width;
      var ccH = clientRect.height;

      // iterate on children dropdowns
      const dropCollection = document.querySelectorAll('.main-dc.active-container .dropdown-menu');
      dropCollection.forEach((item, i) => {
        if(i > 0 && item.classList.contains('show') ){
          // skip first element and calculate growing area of the visible dropdowns
          let itemRect = item.getBoundingClientRect();
          ccLeft = itemRect.left < ccLeft ? itemRect.left : ccLeft;
          ccRight = itemRect.right > ccRight ? itemRect.right : ccRight;
          ccTop = itemRect.top < ccTop ? itemRect.top : ccTop;
          ccBottom = itemRect.bottom > ccBottom ? itemRect.bottom : ccBottom;
          ccW = ccRight - ccLeft;
          ccH = ccBottom - ccTop;
        }
      });

      // define background (container) dimension and position
      ddBg.style.left = `${ccLeft}px`;
      ddBg.style.top = `${ccTop - addSpace}px`;
      ddBg.style.width = `${ccW}px`;
      ddBg.style.height = `${ccH}px`;

      // add class for dropdown with childrens
      if(dropCollection.length > 1){
        ddBg.classList.add('has-sub')
      } else {
        ddBg.classList.remove('has-sub')
      }

      // CONTAINER BACKGROUND FIRST LEVEL (gray bg)
      const ddBgFirst = ddBg.querySelector('.first-level');

      ddBgFirst.style.left = `${ccLeft}px`;
      ddBgFirst.style.top = `${ccTop - addSpace}px`;
      ddBgFirst.style.width = `${clientRect.width}px`;
      ddBgFirst.style.height = `${ccH}px`;
    }
  }

  // document.getElementById('dropdown-bg').addEventListener('transitionend', () => {
  //   console.log('Transition ended');
  //   let elem = document.querySelector('#main-nav .drop-container.main-dc.active-container');
  //   if(elem != null){
  //     elem.classList.add('show-content');
  //   }
  // });
  //
  // document.getElementById('dropdown-bg').addEventListener('transitionstart', () => {
  //   console.log('Transition started');
  //   document.querySelectorAll('#main-nav .drop-container.main-dc').forEach((mainDrop, i) => {
  //     mainDrop.classList.remove('show-content');
  //   });
  // });




  // ---------------------------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------------------
  // DESKTOP MENU
  // ---------------------------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------------------


  function desktopMenu(){
    // const updatePopper = new Event('triggerPopper');


    const navbarNavDropdown = document.querySelector('#navbarNavDropdown');

    if (navbarNavDropdown) {
      // EVENT shown.bs.dropdown ----------------------
      navbarNavDropdown.addEventListener('shown.bs.dropdown', function (item) {
        // console.log('shown.bs.dropdown');
        updatePopperInstance(item);
        // document.dispatchEvent(updatePopper);
      })
      // EVENT hide.bs.dropdown ----------------------
      navbarNavDropdown.addEventListener('hide.bs.dropdown', function (item) {
        // console.log('hide.bs.dropdown');
        updatePopperInstance(item);
      })
    }




    // UPDATE POPPER INSTANCE ----------------------
    function updatePopperInstance(item){
      setTimeout(function () {
        dropContainerSize();
      }, 20);
    }


    // MAIN MENU LOOP
    // ---------------------------------------------------------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------

    var mainDropdownItems = document.querySelectorAll('#navbarNavDropdown a.dropdown-toggle.main-dt');
    mainDropdownItems.forEach(function(mainItem){

      // SET MENU LEVELS
      getMenuLevels(mainItem);


      // EVENT CLICK on .dropdown-toggle  ----------------------
      // Change dropdowns offsets based on opened menu levels
      mainItem.nextSibling.querySelectorAll('a.dropdown-toggle').forEach(function(clickedItem){
        clickedItem.addEventListener('click', function (item) {

          // First Level
          if(item.target.closest('div').classList.contains('main-dc')){

            if(item.target.classList.contains('show')){
              bootstrap.Dropdown.getInstance(mainItem).hide()
              var mainDropdown = initMainDropdown(mainItem, -400);
              mainDropdown.show();

            } else {
              bootstrap.Dropdown.getInstance(mainItem).hide()
              var mainDropdown = initMainDropdown(mainItem);
              mainDropdown.show();

            }

            window.dispatchEvent(new Event('resize'));

            // Other childrens
          } else {
            // console.log('other childrens');
          }
        })
      })

      // VAR DROP CONTAINER
      var dropContainer = mainItem.nextElementSibling; // div.drop-container.main-dc

      // Share active class from .nav-link to parent menu elements
      if(dropContainer.querySelector('.nav-link.active')){
        shareActiveClassToParents(dropContainer.querySelector('.nav-link.active'));
      }

      // FUNCTION Close all the main dropdown elements
      var mainDropdownElementList = [].slice.call(mainDropdownItems)
      function closeMainElements(){
        mainDropdownElementList.map(function (dropdownToggleEl) {
          bootstrap.Dropdown.getInstance(dropdownToggleEl)?.hide();
        })
      }

      // FUNCTION Close all child dropdown elements
      var childDropdownElementList = [].slice.call(mainItem.nextElementSibling.querySelectorAll('li a.dropdown-toggle'))
      function closeChildElements(){
        childDropdownElementList.map(function (childDropdownToggleEl) {
          let bsInstance = bootstrap.Dropdown.getInstance(childDropdownToggleEl)
          if(bsInstance){
            bootstrap.Dropdown.getInstance(childDropdownToggleEl).hide();
          }
        })
      }


      // LISTNERS:
      // Assign active class to body and menu elements
      showHideListners('#navbarNavDropdown', mainItem);


      // EVENT HOVER ----------------------
      // OPEN menu dropdowns on hover
      mainItem.addEventListener('mouseover', function(e){
        if(!mainItem.classList.contains('show')){
          // Show this dropdown
          closeMainElements();

          // Active child element
          // var childActive = dropContainer.querySelector('li a.dropdown-toggle.active') || dropContainer.querySelector('li a') || dropContainer.querySelector('a.active');
          var childActive = dropContainer.querySelector('a.active') || dropContainer.querySelector('li a');

          // OPEN FIRST SUBMENU
          // only if is a dropdown, show the first submenu and assign active submenu classes
          if(childActive?.classList.contains('dropdown-toggle')){
            childActive.classList.add('active');

            // Flip to left if there's an active dropdown
            var mainDropdown = initMainDropdown(mainItem, -400);
            mainDropdown.show();

            // INSTANCE First child dropdown
            bootstrap.Dropdown.getInstance(childActive).hide()
            let firstChildDropdownReference = childActive.closest('ul.dropdown-menu');
            var firstChildDropdown = initFirstChildDropdown(childActive, firstChildDropdownReference);
            firstChildDropdown.show();

          } else {

            // Normal position if the first item isn't a dropdown
            var mainDropdown = initMainDropdown(mainItem);
            mainDropdown.show();
          }

          // SET MENU LEVELS
          getMenuLevels(mainItem);
        }
      });

      // ASSIGN active class to clicked child menu element
      mainItem.nextElementSibling.querySelectorAll('li a.dropdown-toggle').forEach(function(childItems){
        childItems.addEventListener('click', function(e){

          mainItem.nextElementSibling.querySelectorAll('li a.dropdown-toggle').forEach(function(elem){
            elem.classList.remove('active');
          })
          this.classList.add('active');
          shareActiveClassToParents(this);

          // SET MENU LEVELS
          getMenuLevels(mainItem);
        });
      })

      // CLOSE menu dropdowns on scroll
      document.addEventListener('scroll', function(e){
        closeMainElements();
        closeChildElements();
      });

      // CLOSE menu dropdowns on leave browser tab
      document.addEventListener("visibilitychange", (event) => {
        if (document.visibilityState !== "visible") {
          closeMainElements();
          closeChildElements();
        }
      });

    });


    // SUBMENU MENU LOOP
    // ---------------------------------------------------------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------

    var subDropdownItems = document.querySelectorAll('#navbarNavDropdown .main-dc > ul.dropdown-menu a.dropdown-toggle');
    subDropdownItems.forEach(function(subItem){

      // INSTANCE Sub menu dropdowns
      let subDropdownsReference = subItem.closest('ul.dropdown-menu');
      var subDropdowns = initFirstChildDropdown(subItem, subDropdownsReference);
    })


    // RESIZE FUNCTIONS
    // ---------------------------------------------------------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------

      //---------------------------------------------------------
    // ON RESIZE
    window.addEventListener('resize', (event) => {
      if(document.body.classList.contains('open-menu')){
        updatePopperInstance();
      }
    });
  }



  // ---------------------------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------------------
  // MOBILE MENU
  // ---------------------------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------------------

  function mobileMenu(){
    // SET CURRENT MENU CLASS
    function setCurrentMenu(elem){
      var previousMenuLevel = elem.parentElement.closest('.drop-container');
      if(previousMenuLevel && previousMenuLevel.previousSibling.classList.contains('current-menu')){
        previousMenuLevel.previousSibling.classList.remove('current-menu');
      }
      elem.classList.add('current-menu');

      document.querySelector('#mobileNavbar').classList.add('submenu-open');
    }

    // SWITCH SUBMENU NAVIGATOR
    function subMenuNavigator(){

    }

    // EVENT shown.bs.offcanvas ----------------------
    document.querySelector('#mobileNavbar').addEventListener('shown.bs.offcanvas', function (item) {
      // console.log('attivo offcanvas');
    })


    // EVENT shown.bs.dropdown ----------------------
    document.querySelector('#mobileNavbar').addEventListener('shown.bs.dropdown', function (item) {
      // console.log('attivo dropdown');
    })

    // EVENT hide.bs.dropdown ----------------------
    document.querySelector('#mobileNavbar').addEventListener('hide.bs.dropdown', function (e) {

      // prevent dropdown submenu closing when click outside
      if (e.clickEvent) {
        e.preventDefault();
      }
    })



    // MOBILE MENU LOOP
    // ---------------------------------------------------------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------

    var mainDropdownItems = document.querySelectorAll('#mobileNavbar a.dropdown-toggle.main-dt');
    mainDropdownItems.forEach(function(mainItem){

      getMenuLevels(mainItem);

      // CLICK ON MAIN ITEM
      mainItem.addEventListener('click', function(e){
        getMenuLevels(mainItem);
        setCurrentMenu(mainItem);
      })


      // CLICK ON SUB ITEMS: assign active class to clicked child menu element
      mainItem.nextElementSibling.querySelectorAll('li a.dropdown-toggle').forEach(function(childItems){
        childItems.addEventListener('click', function(e){

          mainItem.nextElementSibling.querySelectorAll('li a.dropdown-toggle').forEach(function(elem){
            elem.classList.remove('active');
          })
          this.classList.add('active');
          shareActiveClassToParents(this);

          // SET MENU LEVELS
          getMenuLevels(mainItem);
          setCurrentMenu(this);
        });
      })
    });


    // CLICK ON PREVIOUS BUTTON
    document.getElementById('mobNavBack').addEventListener('click', function(e){
      e.preventDefault();

      let currentSubMenu = document.querySelector('#mobileNavbar .current-menu');
      let subMenuInstance = bootstrap.Dropdown.getInstance(currentSubMenu);
      subMenuInstance.hide();

      currentSubMenu.classList.remove('current-menu');

      // if parent is a submenu
      if(currentSubMenu.closest('.drop-container')){
        currentSubMenu.closest('.drop-container').previousSibling.classList.add('current-menu');

        // else we are in the main dropdown
      } else {
        document.querySelector('#mobileNavbar').classList.remove('submenu-open');
      }
    })



    // RESIZE FUNCTIONS
    // ---------------------------------------------------------------------------------------------------------
    // ---------------------------------------------------------------------------------------------------------

      //---------------------------------------------------------
    // ON RESIZE
    window.addEventListener('resize', (event) => {
      if(document.body.classList.contains('open-menu')){
        // dropContainerSize();
      }
    });
  }



  // ---------------------------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------------------
  // MEDIA QUERY - mobile menu
  // ---------------------------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------------------

  if (window.innerWidth > 992) {
    desktopMenu();
  } else {
    mobileMenu();
  } // END MEDIA QUERY


  // RESIZE FUNCTIONS
  // ---------------------------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------------------

  function resizedw(){
    if (window.innerWidth > 992) {
      desktopMenu();
    } else {
      mobileMenu();
    } // END MEDIA QUERY
  }

  var doit;
  window.onresize = function(){
    clearTimeout(doit);
    doit = setTimeout(resizedw, 100);
  };

}

export { mainNavScripts }
